"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ok = function (item) {
    return {
        isOk: function () { return true; },
        isErr: function () { return false; },
        unwrap: function () { return item; },
        unwrapErr: function () {
            throw new Error('can not unwrap error on Ok');
        },
        unwrapOr: function () { return item; },
        map: function (fn) { return exports.Ok(fn(item)); },
        mapErr: function (fn) { return exports.Ok(item); },
    };
};
exports.Err = function (err) {
    return {
        isOk: function () { return false; },
        isErr: function () { return true; },
        unwrap: function () {
            throw new Error('can not unwrap on Err');
        },
        unwrapErr: function () { return err; },
        unwrapOr: function (d) { return d; },
        map: function (fn) { return exports.Err(err); },
        mapErr: function (fn) { return exports.Err(fn(err)); },
    };
};
var MetricsEngineError = /** @class */ (function (_super) {
    __extends(MetricsEngineError, _super);
    function MetricsEngineError(m) {
        var _this = _super.call(this, m) || this;
        // Set the prototype explicitly. Any subclass will have to manually set the prototype as well.
        // tslint:disable-next-line: max-line-length
        // See: https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, MetricsEngineError.prototype);
        return _this;
    }
    return MetricsEngineError;
}(Error));
exports.MetricsEngineError = MetricsEngineError;
//# sourceMappingURL=Result.js.map